import { createElement } from 'react';

import { createRoot } from 'react-dom/client';
// import eventually from '@zenbusiness/eventually';

import { ENV } from '#client/manifest';

import LocalApp from './LocalApp';

// This will need to be initialized. See available options/methods here:
// https://github.com/zenbusiness/eventually/blob/main/docs/API.md#load
// eventually.load({
//   key: '',
//   destination: '',
//   rudderStackOptions: {}
// });

// Check that service workers are supported (never true outside of HTTPS)
if (ENV.USE_WORKBOX && 'serviceWorker' in navigator) {
  // Use the window load event to keep the page load performant
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${ENV.DEFAULT_SEGMENT}/static/js/service-worker.js`);
  });
}

const element = document.getElementById('root');
const root = createRoot(element);
root.render(createElement(LocalApp));

/* webpack-strip-block:removed */
